<script>
    import {elementDetails} from '../workspacesStore.js';
    import DataTable from '../../DataGrid/DataTable.svelte';
    import QuestionSelectionOptionsColumn from '../../DataGrid/ColumnRenderers/QuestionSelectionOptionsColumn.svelte';
    import {sgettext} from '../../../i18n.js';

    export let rows = $elementDetails ? $elementDetails.questions : [];

    let columns = {
        question_type_display: {
            label: sgettext('$$TYPE$$'),
            width: '20%'
        },
        question_text: {
            label: sgettext('$$QUESTION$$'),
            width: '60%'
        }
    };

    let aggregatedColumns = {
        selectionOptions: {
            label: sgettext('$$SELECTION_OPTIONS$$'),
            width: '20%',
            renderer: QuestionSelectionOptionsColumn,
            props: {
                editable: false
            }
        }
    }
</script>

<DataTable
    small={true}
    {columns}
    {aggregatedColumns}
    {rows}
/>

